import { createMapRegistry } from './create-registry'

export const guardsRegistry = createMapRegistry<unknown>('GuardsRegistry')
